import React from 'react'
import Store from '../../components/users/Store'

const StorePage = () => {
    return (

        <Store />

    )
}

export default StorePage